export type CreanceViewMode = "table" | "grid";

export const CREANCES_PAGE_GUIDE = [
  "Cette page ne montre que les échéances réellement en retard, pas simplement impayées.",
  "Principal dû et pénalités accumulées sont affichés séparément.",
  "Pour reprogrammer une échéance, ouvrez la facture concernée.",
];
